const SATOSHIS_PER_BTC = 100000000;

/**
 * Format currency amount
 * @param {number} amount - Amount in USD
 * @param {Object} options - Formatting options
 * @param {boolean} options.inBitcoin - Display in Bitcoin instead of USD
 * @param {number} options.btcRate - Current BTC to USD rate (required if inBitcoin is true)
 * @param {string} options.bitcoinDisplayMode - Display mode: 'fractional' or 'sats' (default: 'fractional')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, options = {}) => {
  const { inBitcoin = false, btcRate = null, bitcoinDisplayMode = 'fractional' } = options;
  
  if (inBitcoin && btcRate) {
    const btcAmount = amount / btcRate;
    const displayMode = bitcoinDisplayMode || 'fractional';

    if (displayMode === 'sats') {
      const satsAmount = Math.round(btcAmount * SATOSHIS_PER_BTC);
      return new Intl.NumberFormat('en-US').format(satsAmount) + ' sats';
    } else {
      return '₿' + new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 8,
        maximumFractionDigits: 8,
      }).format(btcAmount);
    }
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export default formatCurrency;
